/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
var Sage = {
// All pages
'common': {
init: function() {
// JavaScript to be fired on all pages


  // ---------------------------- SHOWCASE FLEX SLIDER
  $(window).load(function() {
    $('#showcase_slider').flexslider({
      slideshow: true,
      slideshowSpeed: 5000,
      animationSpeed: 1000,
      pauseOnHover: false,
      controlNav: false, //remove slider buttons
      directionNav: false //remove prev/next navigation
    });
  });
  
    $('#showcase .arrow-left').click(function(e){
    $('#showcase_slider').flexslider("prev");
    e.preventDefault();
  });

  $('#showcase .arrow-right').click(function(e){
    $('#showcase_slider').flexslider("next");
    e.preventDefault();
  });
  

  // ---------------------------- TESTIMONIALS FLEX SLIDER
   $(window).load(function() {
    $('#testimonials_slider').flexslider({
      slideshow: true,
      animation: "slide",
      animationLoop: true,
      slideshowSpeed: 4000,
      animationSpeed: 700,
      pauseOnHover: true,
      controlNav: false, //remove slider buttons
      directionNav: false, //remove prev/next navigation
      itemWidth: 200,
      itemMargin: 40,
      minItems: getGridSize(),
      maxItems: getGridSize(),
      move: 1
    });
  });
 
// Dynamically tells flexslider how many thumbs to show.
  $(window).resize(function() {
      var gridSize = getGridSize();
      
      $('#testimonials_slider').data('flexslider').vars.minItems = gridSize;
      $('#testimonials_slider').data('flexslider').vars.maxItems = gridSize;
  });

// Chooses how many thumbnails to show depending on screen size.
function getGridSize() {
  return (window.innerWidth < 768) ? 1 :
  (window.innerWidth < 992) ? 2 : 3;
}
  

  $('#testimonials .arrow-left').click(function(e){
    $('#testimonials_slider').flexslider("prev");
    e.preventDefault();
  });

  $('#testimonials .arrow-right').click(function(e){
    $('#testimonials_slider').flexslider("next");
    e.preventDefault();
  });
  
$(".wpl_search_fields input").attr("placeholder", "Destination or Property");

},
finalize: function() {
// JavaScript to be fired on all pages, after page specific JS is fired
}
},
// Home page
'home': {
init: function() {
// JavaScript to be fired on the home page
},
finalize: function() {
// JavaScript to be fired on the home page, after the init JS
}
},
// About us page, note the change from about-us to about_us.
'about_us': {
init: function() {
// JavaScript to be fired on the about us page
}
},
'properties': {
  init: function() {
    $('#wpl_searchwidget_2').on('change', '#sf2_select_location1_id, #sf2_select_location2_id', function() {
      $('#wpl_search_form_2').submit();
    });
  },
  
  finalize: function() {
    
    // Resize Overview Google Map window on mobile
    $width = $(window).width();
    if ($width < 768) {
      $('.wpl_map_canvas').css('height', '350px');
    }
    
    
    // Resize Google Map window to match image slider height
    function map_resize() {
      $height = $('.bxslider li').height();
      $('.wpl_map_canvas').css('height', $height);
    }
    map_resize();
    $(window).resize(function() {
      map_resize();
    });
    
    // Auto fill Property Name to Check Availability form
    $propertyName = $('h1.title_text').text();
    $autoPropertyName = $('#auto_property_name');
    $autoPropertyName.val($propertyName).css('font-weight', '400');
    
  }
  
  
  
}
};

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
